import TypingEffect from "./pages/VideoShare/TypingEffect"

const Title = ({ title }) => (
  <h1
    css={{
      fontFamily: "Montserrat, serif",
      color: "white",
      width: "100%",
      fontSize: 24,
      minHeight: 29,
      fontWeight: 700,
      textAlign: "center",
      alignSelf: "start",
      margin: 0,
      whiteSpace: `pre-line`,
      // lineHeight: 26px,
    }}
  >
    <TypingEffect text={title} />
    {/* {title} */}
  </h1>
)

export default Title
